import VenueCateringModel from '@/shared/models/venue/VenueCateringModel';
class VenueCateringForm extends VenueCateringModel {
    hideAttributes() {
        return ['id'];
    }
}
export default VenueCateringForm;
